import styles from './chatTitle.module.scss';
import CustomIcon from '@/components/ui/CustomIcon';

type Props = {
  onBackClick?: () => void;
};

const ChatTitle = ({ onBackClick }: Props): React.ReactElement => {
  return (
    <div className={styles.container}>
      <button className={styles['back-button']} onClick={onBackClick}>
        <CustomIcon name="backArrow" width={20} height={20} />
      </button>
      <div className={styles['face-icon']}>
        <CustomIcon name="assistantFace" width={30} height={30} />
      </div>
      <div className={styles['title-info']}>
        <h4 className={styles.title}>480Bot</h4>
        <p className={styles.subtitle}>Estoy aquí para ayudarte</p>
      </div>
    </div>
  );
};

export default ChatTitle;
